import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import "./normalize.css"
import App from "./App";
import { SessionProvider } from "./context/session";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SessionProvider>
      <App />
    </SessionProvider>
  </React.StrictMode>
);
